import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from '@/components/Layout';
import Dashboard from '@/pages/Dashboard';
import Upload from '@/pages/Upload';
import DataManagement from '@/pages/DataManagement';
import ReportSelection from '@/pages/ReportSelection';
import ReportsGallery from '@/pages/ReportsGallery';
import ReportViewer from '@/pages/ReportViewer';
import CustomReportBuilder from '@/pages/CustomReportBuilder';
import MarginAnalysis from '@/pages/MarginAnalysis';
import TopsAnalysis from '@/pages/TopsAnalysis';
import AgentsReports from '@/pages/AgentsReports';
import ClientsAnalysis from '@/pages/ClientsAnalysis';
import AvicarvilAnalysis from '@/pages/AvicarvilAnalysis';
import SuppliersAnalysis from '@/pages/SuppliersAnalysis';
import '@/App.css';
import { Toaster } from '@/components/ui/sonner';

function App() {
  return (
    <div className="App">
      <BrowserRouter basename="/reports-tool">
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Dashboard />} />
            <Route path="upload" element={<Upload />} />
            <Route path="data" element={<DataManagement />} />
            <Route path="selection" element={<ReportSelection />} />
            <Route path="reports" element={<ReportsGallery />} />
            <Route path="reports/margin-analysis" element={<MarginAnalysis />} />
            <Route path="reports/tops-analysis" element={<TopsAnalysis />} />
            <Route path="reports/agents" element={<AgentsReports />} />
            <Route path="reports/avicarvil" element={<AvicarvilAnalysis />} />
            <Route path="reports/clients" element={<ClientsAnalysis />} />
            <Route path="reports/suppliers" element={<SuppliersAnalysis />} />
            <Route path="reports/:reportType" element={<ReportViewer />} />
            <Route path="custom-reports" element={<CustomReportBuilder />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;